export const NonFinancialDataTabs = {
  PersonalDetails: 'personal-details',
  Dependants: 'dependants',
  Health: 'health',
  Vulnerabilities: 'vulnerabilities',
  Employment: 'employment',
  Objectives: 'objectives',
  EstatePlanning: 'estate-planning',
  RiskAndInvestmentPreferences: 'risk-and-investment-preferences',
  TaxAndAdviceMoments: 'tax-and-advice-moments',
  AdvisorsProfessionalConnections: 'advisors-professional-connections',
  SavedMemories: 'saved-memories',
} as const;
